<template>
    <div id="ID-DIV-base-page-srp-pdf">
        <div 
        v-if="data_local_lga_facility_submission_parsed_selected!=undefined && data_local_lga_facility_submission_parsed_selected.length!=0">
            <div id="ID-DIV-pdf-page-1">
                <v-row id="ID-DIV-page-component-panel-control">
                    <v-col cols="12">
                        <div>
                            <h1 class="app-class-section-headings">
                                <!-- replace all underscores in a facility-name with spaces-->
                                <strong>{{data_facility_name.replace(/_/g," ")}}</strong>
                            </h1>
                            <h4 class="app-class-section-headings">
                                <strong>Submission Time : {{data_submission_date}}</strong>
                            </h4>
                        </div>
                    </v-col>
                </v-row>
                <v-row id="ID-DIV-page-component-panel-general-info">
                    <v-col cols="12">
                        <div>
                            <h1 class="app-class-section-headings" 
                            >
                                <strong>General Information</strong>
                            </h1>
                            <!-- ===================================================== -->
                            <!-- SLOT FOR THE PARENT MODULE general_info section -->
                            <!-- ===================================================== -->
                            <slot 
                            name="slot_general_info"
                            v-bind:submission="data_local_lga_facility_submission_parsed_selected">
                            </slot>
                            <!-- ===================================================== -->
                        </div>
                    </v-col>
                </v-row>
                <v-row id="ID-DIV-page-component-panel-media">
                    <v-col cols="12">
                        <div>
                            <h1 class="app-class-section-headings" 
                            >
                                <strong>Media</strong>
                            </h1>
                            <!-- ===================================================== -->
                            <!-- SLOT FOR THE PARENT MODULE media section -->
                            <!-- ===================================================== -->
                            <slot 
                            name="slot_media"
                            v-bind:submission="data_local_lga_facility_submission_parsed_selected">
                            </slot>
                            <!-- ===================================================== -->
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div id="ID-DIV-pdf-page-2">
                <v-row id="ID-DIV-page-component-panel-priority-areas">
                    <v-col cols="12">
                        <div>
                            <h1 class="app-class-section-headings">
                                <strong>Priority Areas</strong>
                            </h1>
                            <ComponentScoreCard 
                            v-bind:prop_submission_review_1="data_local_lga_facility_submissions_parsed_review_1" 
                            v-bind:prop_submission_review_2="data_local_lga_facility_submissions_parsed_review_2" 
                            v-bind:prop_submission_review_3="data_local_lga_facility_submissions_parsed_review_3"/>
                        </div>
                    </v-col>
                </v-row>
                <div class="card" id="ID-DIV-page-component-panel-services-summaries">
                    <div class="card-header">
                        <v-row>
                            <v-col cols="2">
                                <p class="app-class-text-light">
                                    <v-icon color="red" medium style="transform: rotate(180deg);">mdi-triangle</v-icon>
                                    No/Not Available
                                </p>
                            </v-col>
                            <v-col cols="2">
                                <p class="app-class-text-light">
                                    <v-icon color="green" medium>mdi-triangle</v-icon>
                                    Yes/Available
                                </p>
                            </v-col>
                            <v-col cols="2">
                                <p>
                                    <strong>-</strong>
                                    Not Applicable
                                </p>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
            <v-row>
                <v-col cols="12">
                    <!-- ===================================================== -->
                    <!-- SLOT FOR THE PARENT MODULE services_summary section -->
                    <!-- ===================================================== -->
                    <slot 
                    name="slot_services_summaries"
                    v-bind:submission="data_local_lga_facility_submission_parsed_selected">
                    </slot>
                    <!-- ===================================================== -->
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col cols="12" style="text-align:center;">
                    <v-progress-circular
                    :size="70"
                    :width="7"
                    color="green"
                    indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </div>
        <v-row>
            <v-col cols="12">
                <ComponentLoadingIndicator 
                v-bind:prop_show="data_component_loading_indicator.prop_show"
                v-bind:prop_type="data_component_loading_indicator.prop_type" 
                v-bind:prop_heading="data_component_loading_indicator.prop_heading" 
                v-bind:prop_message="data_component_loading_indicator.prop_message" 
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

//########################################
//IMPORTS libs
//########################################
import {Facade_Logger} from '@/libs/facades/facade_logger.js';
import {Api_Client_E4e_Fmoh_Iss} from '@/libs/services_clients/api_client_fmoh_iss';

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS
import ComponentLoadingIndicator from '@/components/ComponentLoadingIndicator';
import ComponentScoreCard from '@/components/ComponentScoreCard';

//MODULE COMPONENTS

//########################################
//CONST AND VARS
//########################################

//########################################
//MAIN
//########################################

export default {
    name: 'BasePageSrpPdf',

    components: {
        //GENERIC COMPONENTS
        ComponentLoadingIndicator,
        ComponentScoreCard

        //MODULE COMPONENTS

        //PAGE_COMPONENTS
    },

    mounted:function()
    {
        action_on_page_load.call(this)
    },

    data: function()
    {
        return {
            //COMPONENT_PROPERTIES-ComponentLoadingIndicator
            data_component_loading_indicator:{
                prop_show:false,
                prop_type:"L",
                prop_heading:"loading default",
                prop_message:"please wait"
            },

            data_local_submissions_summary:[],
            data_local_lga_facility_submission_parsed_selected:[],
            data_local_lga_facility_submissions_parsed_review_1:[],
            data_local_lga_facility_submissions_parsed_review_2:[],
            data_local_lga_facility_submissions_parsed_review_3:[],
            data_local_lga_facility_submissions:[],

            data_facility_name:"",
            data_submission_id:"",
            data_submission_date:""
        }
    },

    computed:{
        //============================
        //LOCAL COMPUTED
        //============================

        //============================
        //VUEX COMPUTED HELPERS
        //============================
        ...mapGetters(
            {
                data_store_submissions_summary: 'data_submissions_summary_getstate_all'
            }
        )
    }
};

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

/**
 * a utility empty promise resolver for passing data
 * 
 * @param {Object} param_data any data to pass
*/
function helper_empty_promise_resolve(param_data)
{
    //OBJ CONTEXT
    var self=this;
    
    return new Promise(
        function(resolve_func,reject_func)
        {
            resolve_func(param_data);
        }
    );
}

/**
 * clear the inputs_validation/flash messages
*/
function helper_clear_flash_messages()
{
    //OBJ CONTEXT
    var self=this;
    
    return self.$store.dispatch(
        'component_alert_flash_action_toggle',
        {
            show:false,
            modal:false,
            type:"",
            heading:"",
            message:""
        }
    );
}

/**
 * show loading modal
 * 
 * @param {boolean} param_show
 * @param {string} param_heading
 * @param {string} param_message
*/
function helper_toggle_loading_indicator(param_show,param_heading,param_message)
{
    //OBJ CONTEXT
    var self=this;
    
    return new Promise(
        function(resolve_func,reject_func)
        {
            self.data_component_loading_indicator.prop_show=param_show;
            self.data_component_loading_indicator.prop_type="L";
            self.data_component_loading_indicator.prop_heading=param_heading;
            self.data_component_loading_indicator.prop_message=param_message;

            resolve_func();
        }
    );
}

/**
 * get and parse submission by id
 * 
 * @param {Array} param_id_review_1 id for the first review
 * @param {Array} param_id_review_2 id for the second review
 * @param {Array} param_id_review_3 id for the third review
 */
function helper_load_submissions_reviews(
    param_id_review_1,
    param_id_review_2,
    param_id_review_3
)
{
    //OBJ CONTEXT
    var self=this;

    return new Promise(
        function(resolve_func,reject_func)
        {
            //==============================================
            //genrate the list
            //==============================================
            
            let review_ids=[]
            if(CONFIG.DISABLE_REVIEWS==false)
            {
                if(param_id_review_1!=undefined)
                {
                    review_ids.push(param_id_review_1)
                }
                if(param_id_review_2!=undefined)
                {
                    review_ids.push(param_id_review_2)
                }
                if(param_id_review_3!=undefined)
                {
                    review_ids.push(param_id_review_3)
                }
            }
            else
            {
                if(param_id_review_1!=undefined)
                {
                    review_ids[0]=param_id_review_1
                }
                if(param_id_review_2!=undefined)
                {
                    review_ids[0]=param_id_review_2
                }
                if(param_id_review_3!=undefined)
                {
                    review_ids[0]=param_id_review_3
                }
            }

            //==============================================
            //CLEAR ALL REVIEW DATA
            //==============================================
            Data_Local_Lga_Facility_Submissions_Parsed_Review_1.set.call(
                self,
                []
            ).then(
                function()
                {
                    return Data_Local_Lga_Facility_Submissions_Parsed_Review_2.set.call(
                        self,
                        []
                    )
                }
            ).then(
                function()
                {
                    return Data_Local_Lga_Facility_Submissions_Parsed_Review_3.set.call(
                        self,
                        []
                    )
                }
            )

            //==============================================
            //RUN THE LOOP
            //==============================================

            review_ids.map(
                function(submission_id,review_index)
                {
                    api_request_get_submission_by_id.call(
                        self,
                        submission_id
                    ).then(
                        function(param_data_submission_raw)
                        {
                            //==========================================
                            //PARSE THE SELECTED-FACILITY-NAME
                            //SUBMISSION WITH THE CORRECT ENGINE
                            //==========================================

                            return ENGINES_selector.generate_submissions_display_model(
                                self.$route.params.form_name,
                                param_data_submission_raw.data
                            );
                        }
                    ).then(
                        function(param_generated_display_models)
                        {
                            //==============================================
                            //ADD THE PARSED DATA TO THE LOCAL-STORE
                            //==============================================

                            if(review_index==0)
                            {
                                return Data_Local_Lga_Facility_Submissions_Parsed_Review_1.set.call(
                                    self,
                                    param_generated_display_models
                                )
                            }
                            else if(review_index==1)
                            {
                                return Data_Local_Lga_Facility_Submissions_Parsed_Review_2.set.call(
                                    self,
                                    param_generated_display_models
                                )
                            }
                            else if(review_index==2)
                            {
                                return Data_Local_Lga_Facility_Submissions_Parsed_Review_3.set.call(
                                    self,
                                    param_generated_display_models
                                )
                            }
                        }
                    ).then(
                        function()
                        {
                            //==========================================
                            //SET THE SELECTED PARSED DATA AS REVIEW_1
                            //==========================================

                            return Data_Local_Lga_Facility_Submission_Parsed_Selected.set.call(
                                self,
                                Data_Local_Lga_Facility_Submissions_Parsed_Review_1.get.call(self)
                            )
                        }
                    )
                }
            );

            resolve_func();
        }
    );
}

//############################################
//API_REQUESTS
//############################################

/**
 * Handle Api-Request responses
 * for getting all forms
 * @param {number} param_items_per_page
 * @param {number} param_page
*/
function api_request_get_submissions_summary(
    param_items_per_page,
    param_page
)
{
    //OBJ CONTEXT
    var self=this;
    
    //make sure to call reject func for every non-OK response
    //to jump to the catch of the calling action
    return new Promise(
        function(resolve_func,reject_func)
        {
            Api_Client_E4e_Fmoh_Iss.forms_action_get_submissions_summary(
                self.$route.params.username,
                self.$route.params.form_name,
                self.$route.params.form_id,
                param_items_per_page,
                param_page
            ).then(
                function(api_response){

                    resolve_func(api_response)
                }
            ).catch(
                function(error){
                    reject_func(error);
                }
            );
        }
    );
}

/**
 * Handle Api-Request responses
 * for get a for by id
 * @param {string} param_id
*/
function api_request_get_submission_by_id(param_id)
{
    //OBJ CONTEXT
    var self=this;
    
    //make sure to call reject func for every non-OK response
    //to jump to the catch of the calling action
    return new Promise(
        function(resolve_func,reject_func)
        {
            Api_Client_E4e_Fmoh_Iss.forms_action_get_submission_by_id(
                self.$route.params.username,
                self.$route.params.form_name,
                self.$route.params.form_id,
                param_id
            ).then(
                function(api_response){

                    resolve_func(api_response)
                }
            ).catch(
                function(error){
                    reject_func(error);
                }
            );
        }
    );
}

//############################################
//DATA_OPPS FOR LOCAL STATE
//############################################
/**
 * handler object for local_data
 * submissions_summary
*/
const Data_Local_Submissions_Summary={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_submissions_summary=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_submissions_summary;
    }
}

/**
 * handler object for local_data
 * submission_selected
*/
const Data_Local_Lga_Facility_Submission_Parsed_Selected={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_submission_parsed_selected=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submission_parsed_selected;
    }
}

/**
 * handler object for local_data
 * review_1 submission
*/
const Data_Local_Lga_Facility_Submissions_Parsed_Review_1={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_submissions_parsed_review_1=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submissions_parsed_review_1;
    }
}

/**
 * handler object for local_data
 * review_2 submission
*/
const Data_Local_Lga_Facility_Submissions_Parsed_Review_2={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_submissions_parsed_review_2=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submissions_parsed_review_2;
    }
}

/**
 * handler object for local_data
 * review_3 submission
*/
const Data_Local_Lga_Facility_Submissions_Parsed_Review_3={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                self.data_local_lga_facility_submissions_parsed_review_3=param_data
                //execute resolve function inside setState-after state set callback
                resolve_func(param_data);
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submissions_parsed_review_3;
    }
}

/**
 * handler object for local_data
 * 
*/
const Data_Local_Lga_Facility_Submissions={
    /**
     * set the array of objects
     * 
     * @param {object[]} param_data
    */
    set:function(param_data)
    {
        //OBJ CONTEXT
        var self=this;

        return new Promise(
            function(resolve_func,reject_func)
            {
                //if more than 3 submissions for a facility get the last 3
                //in order
                if(param_data.length > 3)
                {
                    self.data_local_lga_facility_submissions=param_data.slice(param_data.length-3)
                    //execute resolve function inside setState-after state set callback
                    resolve_func(param_data.slice(param_data.length-3));
                }
                else
                {
                    self.data_local_lga_facility_submissions=param_data
                    //execute resolve function inside setState-after state set callback
                    resolve_func(param_data);
                }
            }
        );
    },
    /**
     * get the list of objects
     * 
     * @return {object[]}
    */
    get:function()
    {
        //OBJ CONTEXT
        var self=this;

        return self.data_local_lga_facility_submissions;
    }
}

//############################################
//ACTIONS
//############################################
/**
 * default action when page loads
 * do initialization here
*/
function action_on_page_load()
{
    //OBJ CONTEXT
    var self=this;

    var api_res_param_retrieved_submissions_summary_full={}
    var api_res_param_retrieved_submissions_summary_data=[]
    var submission_id_data=[]

    helper_clear_flash_messages.call(self).then(
        function()
        {
            return helper_toggle_loading_indicator.call(
                self,
                true,
                "loading submissions",
                "please wait..."
            )
        }
    ).then(
        function()
        {
            //=============================================
            //PULL SUBMISSIONS-SUMMARY DATA
            //=============================================

            //IF data exists in the store already pass it down the chain
            //ELSE make new request
            if(self.data_store_submissions_summary==null)
            {
                return api_request_get_submissions_summary.call(
                    self,
                    0,
                    0
                );
            }
            else
            {
                return helper_empty_promise_resolve.call(
                    self,
                    self.$store.state.data_submissions_summary
                )
            }
        }
    ).then(
        function(param_data_retrieved_submissions_summary)
        {
            //=============================================
            //SAVE TO LOCAL-DATA-STORE
            //=============================================

            //full json response
            api_res_param_retrieved_submissions_summary_full=param_data_retrieved_submissions_summary

            //extracted data attribute from full json response
            api_res_param_retrieved_submissions_summary_data=param_data_retrieved_submissions_summary.data

            return Data_Local_Submissions_Summary.set.call(
                self,
                api_res_param_retrieved_submissions_summary_data
            );
        }
    ).then(
        function()
        {
            //=============================================
            //SAVE TO VUEX-STORE
            //=============================================

            //if no data already
            if(self.data_store_submissions_summary==null)
            {
                return self.$store.dispatch(
                    "data_submissions_summary_action_set_all",
                    api_res_param_retrieved_submissions_summary_full
                )
            }
            else
            {
                return helper_empty_promise_resolve.call(
                    self,
                    {}
                )
            }
        }
    ).then(
        function()
        {
            return helper_toggle_loading_indicator.call(
                self,
                true,
                "analysing submissions",
                "please wait..."
            )
        }
    ).then(
        function()
        {
            //========================================================
            //filter the submission with the id
            //========================================================
            return helper_empty_promise_resolve.call(
                self,
                Data_Local_Submissions_Summary.get.call(self).filter(
                    function(current_submission)
                    {
                        if(current_submission.instance_id==self.$route.params.submission_id)
                        {
                            return true
                        }
                        else
                        {
                            return false
                        }
                    }
                )
            );
        }
    ).then(
        function(param_submission_id_data)
        {
            //in the format yyyy-mm-dd hh:mm:ss.nano
            //split the nano after '.'
            //and replace ' ' with '/'
            self.data_submission_date=(param_submission_id_data[0].date_created.split(".")[0]).replace(" ","/")
            self.data_facility_name=param_submission_id_data[0].facility_name
            self.data_submission_id=param_submission_id_data[0].instance_id

            //========================================================
            //filter and save all submissions from a single facility
            //which has the same [facility_name] as the
            //provided submission_id
            //========================================================
            return Data_Local_Lga_Facility_Submissions.set.call(
                self,
                Data_Local_Submissions_Summary.get.call(self).filter(
                    function(current_submission)
                    {
                        if(current_submission.facility_name==param_submission_id_data[0].facility_name && current_submission.lga==param_submission_id_data[0].lga)
                        {
                            return true
                        }
                        else
                        {
                            return false
                        }
                    }
                ).map(
                    function(current_submission)
                    {
                        return {
                            //in the format yyyy-mm-dd hh:mm:ss.nano
                            //split the nano after '.'
                            //and replace ' ' with '/'
                            text:(current_submission.date_created.split(".")[0]).replace(" ","/"),
                            value:(current_submission.instance_id).toString()
                        }
                    }
                )
            )
        }
    ).then(
        function()
        {
            return helper_toggle_loading_indicator.call(
                self,
                true,
                "loading facility submissions",
                "please wait..."
            )
        }
    ).then(
        function()
        {
            //==========================================================
            //LOAD SUBMISSIONS
            //==========================================================

            return helper_load_submissions_reviews.call(
                self,
                Data_Local_Lga_Facility_Submissions.get.call(self)[0]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[0].value,
                Data_Local_Lga_Facility_Submissions.get.call(self)[1]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[1].value,
                Data_Local_Lga_Facility_Submissions.get.call(self)[2]==undefined?undefined:Data_Local_Lga_Facility_Submissions.get.call(self)[2].value,
            )
        }
    ).then(
        function()
        {
            //==========================================================
            //GENERATE PDF
            //if the noauto=true query parameter is not set
            //==========================================================
            if(self.$route.query.noauto!="true")
            {
                setTimeout(
                    function()
                    {
                        helper_toggle_loading_indicator.call(
                            self,
                            true,
                            "generating pdf",
                            "please wait..."
                        ).then(
                            function()
                            {
                                return ENGINES_selector.helper_generate_pdf_snapshot_page_srp(
                                    self.$route.params.form_name,
                                    self.data_facility_name+"_subid_"+self.data_submission_id,
                                    2,
                                    300
                                )
                            }
                        ).then(
                            function()
                            {
                                return helper_toggle_loading_indicator.call(
                                    self,
                                    false,
                                    "saving report pdf",
                                    "please wait..."
                                )
                            }
                        ).then(
                            function()
                            {
                                //==========================================
                                //RUN END OF CHAIN OPERATIONS
                                //==========================================

                                //CLEAR LOADING-INDICATORS
                                helper_toggle_loading_indicator.call(
                                    self,
                                    false,
                                    "",
                                    ""
                                )
                            }
                        )
                    },
                    3000
                )
            }
            else
            {
                //==========================================
                //RUN END OF CHAIN OPERATIONS
                //==========================================

                //CLEAR LOADING-INDICATORS
                helper_toggle_loading_indicator.call(
                    self,
                    false,
                    "",
                    ""
                )
            }
        }
    ).catch(
        function(err)
        {
            Facade_Logger.log("prom error catch=>"+err);

            return self.$store.dispatch(
                'component_alert_flash_action_toggle',
                {
                    show:true,
                    modal:true,
                    type:"warning",
                    heading:"Error",
                    message:"Sorry,smothing went wrong please try again later"
                }
            );
        }
    );
}
</script>
